// extracted by mini-css-extract-plugin
module.exports = {"content":"PaymentAutoRedirectionAlert_content_3Gycj","footer":"PaymentAutoRedirectionAlert_footer_2U0yi"};